import React, { useEffect } from 'react';
import BroadcastPage from './broadcast/BroadcastPage';
import './users/users.css';
import './users/brand.css';
import './broadcast/broadcast.css';
export default function Broadcast() {
  useEffect(() => { document.body.classList.add('users-brand'); return () => document.body.classList.remove('users-brand'); }, []);
  return <BroadcastPage />;
}
